import * as ACTION_TYPES from '../types';

let initialState = {
  surveyList: [],
  survey: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
      case ACTION_TYPES.GET_SURVEYS:
        return {...state, surveyList: action.data };
      case ACTION_TYPES.DELETE_SURVEY:
        let newList = state.surveyList.filter(survey => survey._id !== action.id);
        return {...state, surveyList: newList };
      case ACTION_TYPES.GET_SURVEY_BY_ID:
        return {...state, survey: action.data};
      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };
      case ACTION_TYPES.DONE:
        return {...state, loading: false };
      case ACTION_TYPES.RESET_SURVEYS:
        return {...state, surveyList: []}
      default:
        return state;
    }
  };